<template>
    <div>
        <div class="cart-header">
            <span class="cart-title">Your Cart</span>
            <a class="hide-cart" @click="$emit('hideCart')">Hide Cart</a>
        </div>
        <div class="cart-empty" v-if="cartItems.length < 1">Your cart is empty</div>
        <div class="cart-listing" v-else>
            <div class="cart-item" v-for="item in cartItems">
                <div class="cart-control" @click="removeFromCart(item.id)">
                    <icons icon="close"></icons>
                </div>
                <div class="cart-description">
                    {{ item.name }} -
                    {{ item.description }}
                </div>
                <div class="cart-price">
                    ${{ item.price }}
                </div>
            </div>
            <button class="button btn-sm btn-primary add-to-cart-btn" @click="goToReview()">Checkout</button>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import * as types from "../store/types"
    export default {
        name: 'PopupCart',
        computed: mapGetters(['cartItems']),
        methods: {
            goToReview() {
                this.cartOpen = false
                this.$router.push({name: 'review'})
            },
            removeFromCart(id) {
                this.$store.dispatch(types.REMOVE_FROM_CART, id)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PopupCart.vue?319c936a